import React from 'react';
import './PinToggle.scss';

export interface PinToggleProps {
  isPinned: boolean;
  onClick?: () => void;
  className?: string;
}

const PinnedIcon: React.FC<{ titleText: string }> = ({ titleText }) => (
  <svg width="17" height="17" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <title>{titleText}</title>
    <g clipPath="url(#clip0_6_8826)">
      <path fillRule="evenodd" clipRule="evenodd" d="M16 9V4H17C17.55 4 18 3.55 18 3C18 2.45 17.55 2 17 2H7C6.45 2 6 2.45 6 3C6 3.55 6.45 4 7 4H8V9C8 10.66 6.66 12 5 12V14H10.97V21L11.97 22L12.97 21V14H19V12C17.34 12 16 10.66 16 9Z" fill="currentColor"/>
    </g>
    <defs>
      <clipPath id="clip0_6_8826">
        <rect width="24" height="24" fill="white"/>
      </clipPath>
    </defs>
  </svg>
);

const PinnableIcon: React.FC<{ titleText: string }> = ({ titleText }) => (
  <svg width="17" height="17" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <title>{titleText}</title>
    <g clipPath="url(#clip0_17_1159)">
      <path d="M14 4V9C14 10.12 14.37 11.16 15 12H9C9.65 11.14 10 10.1 10 9V4H14ZM17 2H7C6.45 2 6 2.45 6 3C6 3.55 6.45 4 7 4H8V9C8 10.66 6.66 12 5 12V14H10.97V21L11.97 22L12.97 21V14H19V12C17.34 12 16 10.66 16 9V4H17C17.55 4 18 3.55 18 3C18 2.45 17.55 2 17 2Z" fill="currentColor"/>
    </g>
    <defs>
      <clipPath id="clip0_17_1159">
        <rect width="24" height="24" fill="white"/>
      </clipPath>
    </defs>
  </svg>
);

export const PinToggle: React.FC<PinToggleProps> = ({
  isPinned,
  onClick,
  className = ''
}) => {
  const label = isPinned ? 'Unpin queue' : 'Pin queue';

  return (
    <span
      className={`cmx-pin-toggle${isPinned ? ' cmx-pin-toggle--active' : ''} ${className}`.trim()}
      onClick={onClick}
      role="button"
      aria-label={label}
      aria-pressed={isPinned}
      tabIndex={0}
      data-testid="pin-toggle"
    >
      {isPinned ? <PinnedIcon titleText={label} /> : <PinnableIcon titleText={label} />}
    </span>
  );
};

PinToggle.displayName = 'PinToggle';
export default PinToggle;
